// OncoRisk.js
import React, { useState, useEffect } from 'react';
import './oncorisk.css';
import OncoRiskContent from './content/oncoriskcontent';
import { getSidebarGroups } from './config/oncorisk-config';
import SearchModal from './content/modules/search-modal';
import { ensureOncoRiskProCookie, getCookieDaysLeft, getCookieId } from './WebserverUser';

import logo from '../../333333.png';

 

function OncoRisk({ optionalParam }) {
  const [selectedItem, setSelectedItem] = useState('home');
  const [cookieId, setCookieId] = useState('');
  const [daysLeft, setDaysLeft] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [searchDetail, setSearchDetail] = useState(null);

  const sidebarGroups = getSidebarGroups();

  const handleItemClick = (itemId) => {
    console.log(`[OncoRisk] Sidebar item clicked: ${itemId}`);
    setSelectedItem(itemId);
  };

  const handleHeaderAction = (action) => {
    console.log(`[OncoRisk] Header action: ${action}`);
    setSelectedItem(action);
  };

  useEffect(() => {
    ensureOncoRiskProCookie();
    setCookieId(getCookieId());
    setDaysLeft(getCookieDaysLeft());
  }, []);
  
  // const isHeaderItem = ['home', 'help', 'settings'].includes(selectedItem); // Not actively used

  console.log(`[OncoRisk] Rendering. Current selectedItem: ${selectedItem}`);

  return (
    <div className="OCRP-oncorisk">
      {/* ... sidebar ... */}
      <div className="OCRP-oncorisk-sidebar">
        <div className="OCRP-sidebar-header">
      <img src={logo} alt="Logo"  className="OCRP-logo"/>
        </div>
        
        <div className="OCRP-sidebar-menu">
          {sidebarGroups.map((group, groupIndex) => (
            <div key={group.id} className="OCRP-sidebar-group">
              {group.title && (
                <div className="OCRP-sidebar-group-title">
                  {group.title}
                </div>
              )}
              <div className="OCRP-sidebar-group-items">
                {group.items.map((item) => (
                  <div
                    key={item.id}
                    className={`OCRP-sidebar-item ${selectedItem === item.id ? 'OCRP-sidebar-item-active' : ''}`}
                    onClick={() => handleItemClick(item.id)}
                  >
                    <i className={`fas fa-${item.icon} OCRP-sidebar-icon`}></i>
                    <span className="OCRP-sidebar-label">{item.label}</span>
                    {item.badge && (
                      <span className="OCRP-sidebar-badge">{item.badge}</span>
                    )}
                  </div>
                ))}
              </div>
              {groupIndex < sidebarGroups.length - 1 && (
                <div className="OCRP-sidebar-divider"></div>
              )}
            </div>
          ))}
        </div>
        <div className="OCRP-sidebar-footer">
          <div
            className="OCRP-cookie-icon"
            data-tooltip={`ID: ${cookieId}\n${daysLeft} days left`}
          >
            <i className="fas fa-cookie-bite"></i>
          </div>
        </div>
      </div>

      <div className="OCRP-oncorisk-content">
        {/* ... header ... */}
        <div className="OCRP-oncorisk-content-header">
          <div className="OCRP-search-container">
            <input
              type="text"
              className="OCRP-header-search"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => {
                const v = e.target.value;
                setSearchTerm(v);
              }}
              onFocus={() => setShowSearch(true)}
            />
            <i className="fas fa-search OCRP-search-icon"></i>
            <SearchModal
              searchTerm={searchTerm}
              isOpen={showSearch}
              onClose={() => setShowSearch(false)}
              onSelect={(item) => {
                setSearchDetail({ ...item, fromSearch: true, time: Date.now() });
                setShowSearch(false);
                setSearchTerm('');
              }}
            />
          </div>
          <div className="OCRP-header-buttons">
            <button 
              className={`OCRP-header-btn ${selectedItem === 'home' ? 'OCRP-header-btn-active' : ''}`}
              onClick={() => handleHeaderAction('home')}
              aria-label="Home"
            >
              <i className="fas fa-home"></i>
              <span>Home</span>
            </button>
            <button 
              className={`OCRP-header-btn ${selectedItem === 'help' ? 'OCRP-header-btn-active' : ''}`}
              onClick={() => handleHeaderAction('help')}
              aria-label="Help"
            >
              <i className="fas fa-question-circle"></i>
              <span>Help</span>
            </button>
            <button 
              className={`OCRP-header-btn ${selectedItem === 'settings' ? 'OCRP-header-btn-active' : ''}`}
              onClick={() => handleHeaderAction('settings')}
              aria-label="Settings"
            >
              <i className="fas fa-cog"></i>
              <span>Settings</span>
            </button>
          </div>
        </div>
 
        {/* Content Body - REMOVED key={selectedItem} */}
        <OncoRiskContent
          selectedItem={selectedItem}
          optionalParam={searchDetail}
          setSelectedItem={setSelectedItem}
        />
      </div>
    </div>
  );
}
export default OncoRisk;